﻿'use strict';

angular.module('ntmApp').factory('Forecast', ['ForecastService', 'FlashService', 'StaffSchedules', 'RoomSchedules', 'Utils', 'ForecastSummary', 'ForecastingBorrowResources', 'Constants',
    function (ForecastService, FlashService, StaffSchedules, RoomSchedules, Utils, ForecastSummary, ForecastingBorrowResources, Constants) {

        function Forecast() {

            if (this.constructor === Forecast) {
                throw new Error("Can not initialize abstract Forecast class! Use CurrentForecast or ScenarioForecast instead");
            }

            var self = this;
            var isChanged = false;

            self.activityType = Constants.ActivityTypes;
            self.schedulingTooltip = 'Manage staff assignments and assign un-assigned activities';

            self.StaffSchedules = new StaffSchedules(self);
            self.RoomSchedules = new RoomSchedules(self);
            self.ForecastSummary = new ForecastSummary(self);
			self.BorrowResources = new ForecastingBorrowResources(self.forecastMode);

			self.loadSchedulesHeaders = function (header, selectedWeek) {
			    self.BorrowResources.load(header, selectedWeek, self.scenarioId, self.StaffSchedules.loadForecastStaffHeaders, self.RoomSchedules.UnderAllocatedStaff.load);
                self.StaffSchedules.loadForecastStaffHeaders(header, selectedWeek);
                self.RoomSchedules.loadForecastRoomHeaders(header, selectedWeek);
                self.RoomSchedules.loadOtherActivitiesHeaders(header, selectedWeek);
				self.RoomSchedules.selectedForecastScope = self.getSelectedForecastScope(header);
				self.BorrowResources.selectedForecastScope = self.getSelectedForecastScope(header);
				self.BorrowResources.permissionToSchedules = header.permissionToSchedules;
            };

            self.loadSummary = function (/*header, weeks*/) {
              //  self.ForecastSummary.load(header, weeks);
            };

            self.locationNotPresent = function (location, staffFacilities) {
                return !(staffFacilities || []).some(function (item) { return location === item.id; });
            };

            self.getSelectedForecastScope = function (header) {

                if (sessionStorage.selectedForecastScopeId && sessionStorage.selectedForecastScopeValue) {

                    var scopeFromSessionStorageExistInList = header.forecastOptionsSummary.forecastScope.some(function (scope) {
                        return scope.id === sessionStorage.selectedForecastScopeId && scope.value === sessionStorage.selectedForecastScopeValue;
                    });

                    if (scopeFromSessionStorageExistInList) {
                        return {
                            id: sessionStorage.selectedForecastScopeId,
                            value: sessionStorage.selectedForecastScopeValue
                        };
                    }
                }

                return get1stForecastScope(header.forecastOptionsSummary.forecastScope);
            };

            function get1stForecastScope(scopes) {

                if (scopes) {

                    return scopes.sort(function (scope1, scope2) {
                        return scope1.value.localeCompare(scope2.value);
                    })[0];
                }

                return {};
            }

            self.initWeekSwitcher = function ($scope) {
                $scope.weeks = [];

                var i = 1;
                var weekRange = {};
                var startDate = moment().add(1, 'day');
                var days = $scope.header.scheduleRollingDate;

                if (parseInt($scope.header.forecastOptionsSummary.weeklyDisplay) === 0) {
                    while (days > 0) {
                        weekRange = {};
                        weekRange.week = i;
                        weekRange.startDate = moment(startDate);
                        if (days > 7) {
                            weekRange.endDate = moment(startDate).add(6, 'day');
                            startDate = moment(startDate).add(7, 'day');
                        } else {
                            weekRange.endDate = moment(startDate).add(days - 1, 'day');
                        }
                        $scope.weeks.push(weekRange);
                        days -= 7;
                        i++;
                    }
                } else {
                    weekRange.week = i;
                    weekRange.startDate = moment(startDate);
                    weekRange.endDate = (days - (moment(startDate).isoWeekday(7)).diff(weekRange.startDate, 'days')) >= 0 ? moment(startDate).isoWeekday(6) : moment(startDate).add(days - 1, 'day');
                    $scope.weeks.push(weekRange);

                    startDate = moment(startDate).isoWeekday(7);
                    days -= startDate.diff(weekRange.startDate, 'days');
                    i++;
                    if (days > 0) {
                        do {
                            weekRange = {};
                            weekRange.week = i;
                            weekRange.startDate = moment(startDate);
                            if (days >= 7) {
                                weekRange.endDate = moment(startDate).add(6, 'day');
                                startDate = moment(startDate).add(7, 'day');
                            } else {
                                weekRange.endDate = moment(startDate).add(days - 1, 'day');
                            }
                            $scope.weeks.push(weekRange);
                            days -= 7;
                            i++;
                        } while (days >= 0);
                    }
                }

                if (sessionStorage.week) {
                    $scope.weeks.forEach(function (item) {
                        if (item.week === parseInt(sessionStorage.week)) {
                            $scope.selectedWeek = item;
                        }
                    });
                }
                if (!$scope.selectedWeek) {
                    $scope.selectedWeek = $scope.weeks[0];
                }
            };

            self.attachWatchers = function ($scope) {
                /*
                $scope.watchCollection = [
                     'Forecast.StaffSchedules.BorrowResources.filter.WeeklyAvailableHoursFilter.selectedDays.length',
                     'Forecast.StaffSchedules.BorrowResources.filter.WeeklyAvailableExHoursFilter.selectedDays.length',
                     'Forecast.StaffSchedules.BorrowResources.filter.WeeklyOvertimeHoursFilter.selectedDays.length',
                     'Forecast.StaffSchedules.BorrowResources.filter.WeeklyAssignedHoursFilter.selectedDays.length',
                     'Forecast.StaffSchedules.BorrowResources.filter.WeeklyCapacityHoursFilter.selectedDays.length'
                ];

                $scope.$watchGroup($scope.watchCollection, function () {
                    $scope.Forecast.StaffSchedules.BorrowResources.performFiltering();
                });
                */
                $scope.$watch('Forecast.RoomSchedules.UnderAllocatedStaff.Filter.WeeklyAvailableHoursFilter.selectedDays.length', function () {
                    $scope.Forecast.RoomSchedules.UnderAllocatedStaff.performFiltering();
                });
            };

            self.isAutoCompleteEmpty = function (value) {
                return Utils.IsTypeheadEmpty(value);
            };

            self.toggleDowItemSelection = function (current, items) {

                var newSelectionState = !current.isSelected;

                items.forEach(function (item) {
                    item.isSelected = false;
                });

                current.isSelected = newSelectionState;
            };

            self.toggleSummary = function () {
                self.showSummary = !self.showSummary;
            };

            self.loadRightPanes = function (header, selectedWeek) {
                self.RoomSchedules.loadRightPanes(header, selectedWeek);
                self.StaffSchedules.loadRightPanes(header, selectedWeek);
            };

            self.setSchedulingMode = function (mode) {
                self.schedulingMode = mode;
            };

            self.isStateChanged = function () {
                return isChanged;
            };

            self.setChangedState = function (state) {
                isChanged = state;
            };

            self.getUniqueIcons = function (activities) {

                var icons = activities.filter(function (activity) {
                    return activity.activityIcon;
                }).map(function (activity) {
                    return {
                        icon: Constants.ActivityTypes.getIconSrc(activity),
                        color: Constants.ActivityTypes.getIconColor(activity.activityIcon)
                    };
                }).unique(function (icon1, icon2) {
                    return icon1.icon === icon2.icon &&
                           icon1.color === icon2.color;
                });

                return icons;
            };

            self.isLoading = function () {
                return (self.StaffSchedules.dataLoading && self.schedulingMode === Constants.ForecastSchedulingMode.Staff) ||
                       (self.RoomSchedules.dataLoading && self.schedulingMode === Constants.ForecastSchedulingMode.Room) ||
                       self.dataLoading;
            };
        }

        return (Forecast);
    }]);


angular.module('ntmApp').factory('CurrentForecast', ['Forecast', function (Forecast) {

    function CurrentForecast(mode) {

        this.forecastMode = mode;
        Forecast.call(this);
    }

    CurrentForecast.prototype = Object.create(Forecast.prototype);
    CurrentForecast.prototype.constructor = CurrentForecast;

    CurrentForecast.prototype.prepareDataForRequest = function () {
        return {
            forecastMode: this.forecastMode
        };
    };

    return (CurrentForecast);
}]);

angular.module('ntmApp').factory('ScenarioForecast', ['Forecast', function (Forecast) {

    function ScenarioForecast(mode) {

        this.forecastMode = mode;
        Forecast.call(this);
    }

    ScenarioForecast.prototype = Object.create(Forecast.prototype);
    ScenarioForecast.prototype.constructor = ScenarioForecast;

    ScenarioForecast.prototype.setSelectedScenario = function (scenario) {
        this.scenarioId = scenario.id;
        this.scenarioName = scenario.value;
    };

    ScenarioForecast.prototype.prepareDataForRequest = function () {
        return {
            forecastMode: this.forecastMode,
            scenarioBreadcrumb: this.scenarioId,
            scenarioName: this.scenarioName
        };
    };

    return (ScenarioForecast);

}]);